module.exports = __webpack_public_path__ + "img/556F42_112817_81927F_223E24-256px.567183c4.png";